import { render, staticRenderFns } from "./InstagramEntity.vue?vue&type=template&id=61d59ccb&"
import script from "./InstagramEntity.vue?vue&type=script&lang=js&"
export * from "./InstagramEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports